module.exports = __webpack_public_path__ + "img/footer-pattern-partial.c6b0de81f13020397055fb186c9131f8.svg";